import { JsonFragment } from '@ethersproject/abi'

export const ERC20: JsonFragment[] = require('./ERC20.json')
export const Gladiator: JsonFragment[] = require('./Gladiator.json')
export const Knight: JsonFragment[] = require('./Knight.json')
export const Multicall2: JsonFragment[] = require('./Multicall2.json')
